// src/config/pricing.js
//
// Prix Premium affiché dans l'app web (label commercial formaté FR).
// ⚠️ Doit rester synchronisé MANUELLEMENT avec :
//   - le Price Stripe réellement facturé : frontend/functions/src/stripe.js (line_items.price) ;
//   - le template email : frontend/functions/src/emails.js ("Montant"), qui NE PEUT PAS importer
//     ce fichier (contexte de build séparé Cloud Functions) → valeur en dur là-bas ;
//   - le prix App Store Connect (mobile : affiché via RevenueCat priceString, automatique).
export const PREMIUM_PRICE_LABEL = '8,99€';
